import { render, staticRenderFns } from "./createFuncionario.vue?vue&type=template&id=a6498784&scoped=true"
import script from "./createFuncionario.vue?vue&type=script&lang=js"
export * from "./createFuncionario.vue?vue&type=script&lang=js"
import style0 from "./createFuncionario.vue?vue&type=style&index=0&id=a6498784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6498784",
  null
  
)

export default component.exports